import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnInit,
  QueryList,
  SecurityContext,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { jsonrepair } from 'jsonrepair';
import { Subscription, tap } from 'rxjs';
import { CloseStreamComponent } from '../../../components-track/close-stream/close-stream.component';
import { InitStreamViewComponent } from '../../../components-track/init-stream-view/init-stream-view.component';
import { PromotionVideoPopupComponent } from '../../../components/promotion-video-popup/promotion-video-popup.component';
import {
  ChatObject,
  GenericChatTypesUi,
  GenericStreamListForUserUse,
  GenericUserStreamWithProgress,
  KeyQuestionUi,
  ResponseType,
  TextType,
  VideoObject
} from '../../../interfaces/responsedata.ts/generic-streams';
import { GenericStreamService } from '../../../service/generic-stream.service';
import { UserdataService } from '../../../service/userdata.service';
import { GenAiService } from './../../../service/gen-ai.service';
import {
  OpenQuestionDialogState,
  StepNotCompletedComponent,
} from './step-not-completed/step-not-completed.component';
import { StepPreviewComponent } from './step-preview/step-preview.component';
import { UserRagComponent } from './user-rag/user-rag.component';
import { SearchResultComponent } from './webresearch/search-result/search-result.component';
import { WebresearchComponent } from './webresearch/webresearch.component';

const TEXTAREA_MAX_HEIGHT = 200;

@Component({
  selector: 'app-generic-stream',
  standalone: false,
  templateUrl: './generic-stream.component.html',
  styleUrl: './generic-stream.component.scss',
})
export class GenericStreamComponent implements OnInit {
  protected genService = inject(GenericStreamService);
  protected fb = inject(FormBuilder);
  protected ai = inject(GenAiService);
  protected cd = inject(ChangeDetectorRef);
  protected dialog = inject(MatDialog);
  protected sanitizer = inject(DomSanitizer);
  protected router = inject(Router);
  protected userdataService = inject(UserdataService);
  private destroyRef = inject(DestroyRef);

  // Stream Data
  public streamData: GenericStreamListForUserUse | undefined;
  protected userStream: GenericUserStreamWithProgress | undefined;

  protected turnCounterValueForNextQuestion: number = 3;
  protected uploadLimiter = 3;
  protected uploadCounter = 0;
  public currentStep: number = 0;
  public currentKeyQuestionIndex: number = 0;
  public turnCounter: number = 0;
  streamType: string = '';
  showSubmenue: boolean = false;
  isLoading: boolean = false;
  aiRunning: boolean = false;
  skipStepPreview: boolean = false;
  suggestBtnActive: boolean = false;
  contentChangedForClosing: boolean = false;
  rueckfrageMode = false;

  error: string | undefined;
  sub?: Subscription;
  briefingMaterial: string[] | undefined;
  chat: ChatObject[] = [];
  chatInput: any = this.fb.control('');
  disableInput: boolean = false;
  showPromotion: boolean = true;
  @ViewChild('chatarea') chatContent!: ElementRef;
  @ViewChild('textarea') textareaEl!: ElementRef<HTMLTextAreaElement>;
  @ViewChildren('targetKeyQuestion') targetKeyQuestion!: QueryList<
    ElementRef<HTMLElement>
  >;
  @ViewChild('keyQuestionsScrollContainer')
  keyQuestionsScrollContainer!: ElementRef<HTMLElement>;

  currentKeyQuestions: KeyQuestionUi[] = [];
  currentThreadId: string | undefined;

  letters: string[] = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ];

  async ngOnInit(): Promise<void> {
    let urlPart = window.location.href.split('/').pop() || '';
    let decodedUrlPart = urlPart;
    let previousValue = '';
    while (decodedUrlPart !== previousValue) {
      previousValue = decodedUrlPart;
      decodedUrlPart = decodeURIComponent(decodedUrlPart);
    }
    let [streamId, queryString] = decodedUrlPart.split('?');
    let cid = null;
    if (queryString) {
      const params = new URLSearchParams(queryString);
      cid = params.get('cid');
    }

    this.skipStepPreview =
      (await this.userdataService.getUserDataByKey('showAiHintDialog')) ||
      false;

    if (cid && streamId) {
      let d = await this.genService.getOneGenericStream(cid);
      if (d === false) return;
      this.streamData = d;
      this.streamType =
        this.streamData.categoryId[this.streamData.categoryId.length - 1];

      let s = await this.genService.getOneGenericUserStream(streamId);
      if (s === false) return;
      this.userStream = s;
      console.log("Stream", d);
      // console.log("UserStream", s);

      if (!this.userStream?.progressCreated) {
        // First run
        this.openInitStreamView();
        await this.genService.createGenericUserStreamProgress(
          this.userStream!.id,
          this.streamData!.steps[this.currentStep].id,
          this.currentThreadId || ''
        );
        this.updateHistory();
      } else {
        this.loadHistory();

        // console.log("Chatlength", this.chat.length);
        if (this.chat.length === 0) {
          this.initializeStep();
        }
        this.scrollToBottom();
      }
    }

    this.autoResizeTextarea();
  }
  async generateClosing(): Promise<boolean | void> {
    if (this.contentChangedForClosing === false) {
      return true;
    }

    this.isLoading = true;
    // call an dresponse call to LLM
    let result = await this.ai.genericAiPost(
      this.userStream!.id,
      this.streamData!.steps[this.currentStep].id,
      GenericChatTypesUi.CLOSING,
      '',
      this.currentStep,
      undefined,
      this.currentThreadId,
    );
    this.isLoading = false;

    if (result === false) return false;

    // console.log("LLM response received:", result);

    if (!this.userStream?.results) this.userStream!.results = [];
    let exist = this.userStream?.results.find(
      (r) => r.stepId === this.streamData!.steps[this.currentStep].id,
    );

    let type = 'step-result';
    // if (this.currentStep === this.streamData!.steps.length - 1) {
    //     type = "stream-result";
    // }

    let refId: string | undefined | false;
    if (result.type === 'CLS_LP') {
      refId = await this.genService.generateLpLink(this.userStream!.id);
      if (refId === false) {
        alert('KEINE REF ID');
        return false;
      }
      // this.lpReferenceId = refId;
      // this.landingPageLink = `${appurl}/projectpage?pid=${this.lpReferenceId}`;
    }

    if (!exist) {
      let newResult = {
        stepId: this.streamData!.steps[this.currentStep].id,
        name: this.streamData!.steps[this.currentStep].name,
        created: new Date().getTime(),
        type: type,
        refId: refId || undefined,
        variant: result.type,
        data: JSON.parse(JSON.stringify(result.data)),
      };
      this.userStream!.results = [...this.userStream!.results, newResult];
    } else {
      this.userStream?.results.forEach((r) => {
        if (r.stepId === this.streamData!.steps[this.currentStep].id) {
          r.data = JSON.parse(JSON.stringify(result.data));
          r.type = type;
          if (refId) r.refId = refId;
          r.variant = result.type;
          r.updated = new Date().getTime();
        }
      });
    }

    this.userStream!.results = JSON.parse(
      JSON.stringify(this.userStream!.results),
    );

    await this.genService.updateGenericUserStreamResults(
      this.userStream!.id,
      this.userStream?.results || [],
    );
    return true;
  }
  async handleResultItemEvents(eventData: {
    type: string;
    resultData: any;
  }): Promise<void> {
    // console.log("Eventdata", eventData);

    if (eventData.type === 'export-miro') {
      this.isLoading = true;
      await this.ai.genAiMiroExport(eventData.resultData.data);
      this.isLoading = false;
    }

    if (eventData.type === 'download-pdf') {
      // createFile
      this.isLoading = true;
      let file = await this.genService.createFileFromResultData(
        eventData.resultData.name,
        eventData.resultData.data,
        eventData.resultData.type,
        eventData.resultData.variant,
      );
      this.isLoading = false;
      if (file === false) return;

      console.log(file);

      this.userStream?.results.forEach((r) => {
        if (r.stepId === eventData.resultData.stepId) {
          r.fileId = file.fileData.id;
          r.file = {
            id: file.fileData.id,
            fileName: file.fileData.identifer,
            fileSize: file.fileData.size,
            dateCreated: new Date().getTime(),
          };
        }
      });

      // Download/Open PDF in file.buffer Object
      this.handlePDFBuffer(file, 'download');
    }

    if (eventData.type === 'close') {
      // Actually no case
    }

    this.userStream?.results.forEach((result) => {
      if (result.stepId === eventData.resultData.stepId) {
        result.data = eventData.resultData.data;
        this.genService.updateGenericUserStreamResults(
          this.userStream!.id,
          this.userStream?.results || [],
        );
      }
    });
  }
  proceedWithNextKeyQuestion() {
    this.turnCounter = 0;
    let index = this.currentKeyQuestionIndex + 1;
    if (index >= this.currentKeyQuestions.length - 1) {
      index = this.currentKeyQuestions.length - 1;
    }
    this.setKeyQuestionActive(index);
  }
  handlePDFBuffer(
    file: any,
    action: 'download' | 'open' | 'inline' = 'download',
  ) {
    try {
      if (!file || !file.buffer) {
        console.error('Kein Buffer gefunden');
        return;
      }

      let bufferData = file.buffer;
      if (bufferData.type === 'Buffer' && bufferData.data) {
        bufferData = new Uint8Array(bufferData.data);
      }

      const blob = new Blob([bufferData], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      switch (action) {
        case 'download':
          const link = document.createElement('a');
          link.href = url;
          link.download =
            file.fileData.identifer || `document_${Date.now()}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          break;

        case 'open':
          window.open(url, '_blank');
          break;

        case 'inline':
          this.sanitizer.bypassSecurityTrustResourceUrl(url);
          break;
      }

      // Cleanup
      if (action !== 'inline') {
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
      }
    } catch (error) {
      console.error('Fehler beim Verarbeiten des PDF-Buffers:', error);
    }
  }
  setActiveAiRunningError() {
    this.error = 'An active process is already running.';
    setTimeout(() => {
      this.error = undefined;
    }, 3000);
  }
  clickSuggestion(
    text: string,
    suggestion: any,
    hidden: boolean = false,
    suggestionClicked: boolean = true,
  ) {
    if (this.aiRunning === true) {
      console.log('clickSuggestion');
      this.setActiveAiRunningError();
      return;
    }
    let userChatId = `user-${new Date().getTime()}`;
    let id = `llm-${new Date().getTime()}`;

    let sendingText = 'My choice is:' + text;
    // Add Userinput to Chat
    this.chat.push({
      id: userChatId,
      text: sendingText,
      textType: TextType.USER,
      finished: false,
      responseType: ResponseType.TEXT,
      hidden: true,
    });
    this.cd.detectChanges();
    this.chat.push({
      id: id,
      textType: TextType.AI,
      finished: false,
      hidden: false,
      aiRunning: true,
    });
    // Collect Data for Server Post
    let promptType: GenericChatTypesUi = GenericChatTypesUi.CHAT;
    // Start Chat Conversation
    this.llmChat(id, promptType, sendingText, undefined);
  }
  getSafeHtml(text: string): string {
    // Escape HTML erst, dann Markdown parsen
    const escaped = text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return (
      this.sanitizer.sanitize(SecurityContext.HTML, escaped)?.toString() || ''
    );
  }
  setKeyQuestionActive(index: number) {
    this.currentKeyQuestions.forEach(
      (question, i) => (question.active = i === index),
    );
    this.currentKeyQuestionIndex = index;
    this.currentKeyQuestions[index].resolved = true;
    this.turnCounter = 0;

    // console.log("KeyQuestion Index", this.currentKeyQuestionIndex);

    setTimeout(() => {
      if (!this.isKeyQuestionInViewPort(index)) {
        this.scrollToElement(index);
      }
    }, 100);
    this.standaloneChat('GEN_Rediscuss', `q${index + 1}`);
    // this.clickSuggestion("Lets JUMP into discussion of question q" + (index + 1) + ": " + this.currentKeyQuestions[index].description, null, true, false);
  }
  async resetStepResult() {
    let i = confirm(
      'Are you sure you want to reset the step? All communication and results will be deleted for this step.',
    );
    if (!i) return;
    this.currentThreadId = this.userStream!.history[0].threadId || undefined;
    this.chat = [];
    this.currentKeyQuestions.forEach((i) => {
      i.active = false;
      i.resolved = false;
    });

    this.briefingMaterial = undefined;
    if (this.userStream) {
      this.userStream.results = this.userStream?.results?.filter(
        (r) => r.stepId !== this.streamData!.steps[this.currentStep].id,
      );
      this.userStream.results = this.userStream?.results?.filter(
        (r) =>
          r.stepId !==
          this.streamData!.steps[this.currentStep].id + '-briefing-material',
      );
      this.genService.updateGenericUserStreamResults(
        this.userStream!.id,
        this.userStream?.results || [],
      );
    }
    await this.updateHistory();
    this.initializeStep();
  }
  async loadHistory() {
    // console.log("Step ID", this.streamData?.steps[this.currentStep].id);
    // console.log("Stream", this.userStream);

    if (!this.userStream!.history) return;
    for (let i = 0; i < this.streamData!.steps.length; i++) {
      if (this.streamData!.steps[i].id === this.userStream?.currentStepId) {
        this.currentStep = i;
      }
    }
    let currentHistory = this.userStream!.history.find(
      (s) => s.stepId === this.streamData!.steps[this.currentStep].id,
    );
    if (!currentHistory) return;
    this.chat = JSON.parse(JSON.stringify(currentHistory.chat));
    this.chat.forEach((c) => {
      c.aiRunning = false;
    });
    this.currentKeyQuestions = JSON.parse(
      JSON.stringify(currentHistory.keyQuestions),
    );
    this.currentThreadId = currentHistory.threadId || this.userStream!.history[0].threadId;

    this.checkSuggestBtnActiveAnd();
    // console.log("===== Load History =====");
    // console.log(currentHistory);
  }
  async updateHistory(): Promise<boolean> {
    let exists = this.userStream!.history?.find(
      (s) => s.stepId === this.streamData!.steps[this.currentStep].id,
    );
    if (!this.userStream!.history) {
      this.userStream!.history = [];
      for await (const question of this.streamData!.steps[this.currentStep]
        .keyQuestions) {
        let q = JSON.parse(JSON.stringify(question));
        q.resolved = false;
        q.active = false;
        this.currentKeyQuestions.push(q);
      }
      this.userStream!.history.push({
        stepId: this.streamData!.steps[this.currentStep].id,
        chat: JSON.parse(JSON.stringify(this.chat)),
        keyQuestions: JSON.parse(JSON.stringify(this.currentKeyQuestions)),
      });
    } else if (!exists) {
      this.userStream!.history.push({
        stepId: this.streamData!.steps[this.currentStep].id,
        chat: JSON.parse(JSON.stringify(this.chat)),
        keyQuestions: JSON.parse(JSON.stringify(this.currentKeyQuestions)),
      });
    } else {
      for await (let step of this.userStream!.history) {
        if (step.stepId === this.streamData!.steps[this.currentStep].id) {
          step.chat = JSON.parse(JSON.stringify(this.chat));
          step.keyQuestions = JSON.parse(
            JSON.stringify(this.currentKeyQuestions),
          );
          step.threadId = this.currentThreadId;
        }
      }
    }

    return await this.genService.updateGenericUserStreamHistory(
      this.userStream!.id,
      this.userStream!.history,
      this.currentThreadId || ""
    );
    // console.log("===== Update History =====");
    // console.log(this.userStream!.history);
  }
  async openPromotionVideo(videoData: VideoObject) {
    let dia = this.dialog.open(PromotionVideoPopupComponent, {
      panelClass: 'small-dialog',
      autoFocus: false,
      data: videoData,
    });
  }
  async openStepPreview(forceOpen = false) {
    if (this.skipStepPreview === true && forceOpen === false) return;

    let dia = this.dialog.open(StepPreviewComponent, {
      panelClass: 'small-dialog',
      autoFocus: false,
      data: {
        name: this.streamData?.steps[this.currentStep]?.name,
        keyQuestions:
          this.streamData?.steps[this.currentStep]?.keyQuestions || [],
        skipStepPreview: this.skipStepPreview,
      },
    });
    dia.afterClosed().subscribe(async (result) => {
      if (this.skipStepPreview === false) {
        if (result && result === true) {
          this.skipStepPreview = true;
        } else {
          this.skipStepPreview = false;
        }
      }

      let resultUpdate = await this.userdataService.showAiHintDialogValue(
        this.skipStepPreview,
      );
      if (resultUpdate === false) {
        console.error('Could not update skipStepPreview value on server.');
        return;
      }
    });
  }
  async openInitStreamView() {
    let overviewData: { name: string; description: string }[] = [];
    for await (const step of this.streamData!.steps) {
      overviewData.push({ name: step.name, description: step.description });
    }
    let dia = this.dialog.open(InitStreamViewComponent, {
      data: { title: this.streamData!.name, data: overviewData },
      panelClass: 'full-screen',
      disableClose: true,
      autoFocus: false,
    });

    dia.afterClosed().subscribe((result) => {
      if (!result) return;
      this.initializeStep();
    });
  }
  async initializeStep(): Promise<true> {
    this.currentThreadId = this.userStream!.history[0].threadId || undefined;
    this.chat = [];
    this.suggestBtnActive = false;

    await this.loadHistory();
    let existOpenQuestions = this.currentKeyQuestions.find(
      (q) => q.resolved === true,
    );
    if (!existOpenQuestions) {
      this.currentKeyQuestions = [];
      this.openStepPreview();
    }
    if (this.currentKeyQuestions.length === 0) {
      for await (const question of this.streamData!.steps[this.currentStep]
        .keyQuestions) {
        let q = JSON.parse(JSON.stringify(question));
        q.resolved = false;
        q.active = false;
        this.currentKeyQuestions.push(q);
      }
    }

    if (this.aiRunning === true) {
      this.setActiveAiRunningError();
      return true;
    }
    if (this.chat.length == 0) {
      let id = `llm-${new Date().getTime()}`;
      let content: string = '';
      let promptType: GenericChatTypesUi = GenericChatTypesUi.INITIALIZE;
      let promptId: string | undefined = undefined;
      this.chat.push({
        id: id,
        textType: TextType.AI,
        finished: false,
        hidden: false,
        aiRunning: true,
      });
      this.llmChat(id, promptType, content, promptId);
    }
    this.scrollToBottom();
    this.cd.detectChanges();

    return true;
  }
  chatEvent(event: KeyboardEvent | Event | null) {
    if (this.chatInput.value.length > 2500) {
      this.error = 'Input exceeds maximum length of 2500 characters.';
      setTimeout(() => {
        this.error = '';
      }, 3000);
      return;
    }
    // Bei Shift+Enter: Zeilenumbruch erlauben und nicht senden
    if (event && 'shiftKey' in event && (event as KeyboardEvent).shiftKey) {
      return;
    }
    if (this.aiRunning === true) {
      this.setActiveAiRunningError();
      return;
    }
    this.chatInput.value = this.chatInput.value.replace(/\n$/, '');

    if (!this.chatInput.value.trim()) {
      this.error = 'Input cannot be empty';
      console.warn('Message is empty or only contains whitespace.');
      return;
    }
    let inputValue = this.chatInput.value;
    this.chatInput.setValue('');

    let userChatId = `user-${new Date().getTime()}`;
    let id = `llm-${new Date().getTime()}`;

    // Add Userinput to Chat
    this.chat.push({
      id: userChatId,
      text: inputValue,
      textType: TextType.USER,
      finished: false,
      responseType: ResponseType.TEXT,
      hidden: false,
    });
    this.cd.detectChanges();
    this.chat.push({
      id: id,
      textType: TextType.AI,
      finished: false,
      hidden: false,
      aiRunning: true,
    });

    // Collect Data for Server Post
    let content: string = inputValue;
    let promptType: GenericChatTypesUi = GenericChatTypesUi.CHAT;
    let promptId: string | undefined = undefined;

    // Start Chat Conversation
    this.llmChat(id, promptType, content, promptId);
  }
  standaloneChat(
    promptId: string,
    content: string = '',
    keepThread: boolean = false,
  ) {
    if (this.aiRunning === true) {
      this.setActiveAiRunningError();
      return;
    }
    let id = `llm-${new Date().getTime()}`;
    this.chat.push({
      id: id,
      textType: TextType.AI,
      finished: false,
      hidden: false,
      aiRunning: true,
    });
    this.llmChat(id, GenericChatTypesUi.STANDALONE, content, promptId);
  }
  checkSuggestBtnActiveAnd() {
    let userContentExists = this.chat.some((c) => c.textType === 'USER');
    if (userContentExists === true) {
      this.suggestBtnActive = true;
    }
  }

  canUseCoachMe(): boolean {
    if (this.disableInput || this.aiRunning) {
      return false;
    }

    return this.suggestBtnActive;
  }

  canGoNextStep(): boolean {
    if (this.disableInput || this.aiRunning) {
      return false;
    }

    return this.chat.some((entry) => entry.textType === 'USER');
  }
  async checkModeForKeyQuestionInString(
    text: string,
  ): Promise<{ text: string; keyQuestionNumber: number | undefined }> {
    const modeRegex = /\[mode\]\s*=\s*q(\d+)/gi;
    const matches = Array.from(text.matchAll(modeRegex));

    if (matches.length === 0) {
      return { text, keyQuestionNumber: undefined };
    }

    const activatedIndices = new Set<number>();
    let keyQuestionNumber: number | undefined = undefined;

    // Verarbeite alle Matches
    for (const match of matches) {
      const questionNumber = parseInt(match[1]);
      const index = questionNumber - 1;

      // Validierung
      if (
        questionNumber > 0 &&
        index < this.currentKeyQuestions.length &&
        !activatedIndices.has(index)
      ) {
        keyQuestionNumber = index;
        // Aktiviere Question
        this.currentKeyQuestions.forEach(
          (question, i) => (question.active = i === index),
        );
        this.currentKeyQuestions[index].resolved = true;
        this.currentKeyQuestionIndex = index;
        activatedIndices.add(index);
        // this.turnCounter = 0;
      }

      // Entferne Pattern aus Text
      text = text.replace(match[0] + '.', '');
      text = text.replace(match[0], '');
    }

    // Scroll zum letzten aktivierten Element
    if (activatedIndices.size > 0) {
      const lastIndex = Math.max(...activatedIndices);

      setTimeout(() => {
        if (!this.isKeyQuestionInViewPort(lastIndex)) {
          this.scrollToElement(lastIndex);
        }
      }, 100);
    }

    text = text
      .replaceAll('() ?', '')
      .replaceAll('****', '')
      .replaceAll('()', '')
      .replaceAll('  ', ' ');

    return { text: text.trim(), keyQuestionNumber: keyQuestionNumber };
  }
  llmChat(
    id: string,
    promptType: GenericChatTypesUi,
    content: any,
    promptId: string | undefined = undefined,
    hidden: boolean = false,
  ) {
    this.error = undefined;
    this.scrollToBottom();
    this.contentChangedForClosing = true;
    this.cd.detectChanges();

    this.sub = this.ai
      .genericStreamAiPost(
        this.userStream!.id,
        this.streamData!.steps[this.currentStep].id,
        promptType,
        content,
        this.currentStep,
        promptId,
        this.currentThreadId,
      )
      .subscribe((evt) => {
        this.chat.forEach(async (c) => {
          if (c.id !== id) {
            return;
          }
          this.scrollToBottom();
          this.disableChatWindow();
          if (evt.type === 'token') {
            // Get Mode of Text (Suggestion/Text)
            c.responseType = ResponseType.TEXT;
            if (
              ((evt.text.indexOf('[') !== -1 && evt.text.indexOf('{') !== -1) ||
                (evt.text.indexOf('}') !== -1 &&
                  evt.text.indexOf(']') !== -1)) &&
              evt.text.indexOf('sug_') !== -1
            ) {
              c.responseType = ResponseType.SUGGESTION;
            }

            switch (c.responseType) {
              case ResponseType.SUGGESTION:
                evt.text = evt.text.replaceAll('```json', '');
                evt.text = evt.text.replaceAll('```', '');
                evt.text = evt.text.trim();

                // Hilfsfunktion für Array-Reparatur
                const repairAndParseArray = (text: string): any[] | null => {
                  // 1. Extrahiere JSON
                  const jsonRegex = /(\{[\s\S]*\}|\[[\s\S]*\])/;
                  const match = text.match(jsonRegex);
                  let textToParse = match ? match[0] : text;

                  const original = textToParse; // Für Logging

                  // 2. Erkenne Pattern: }, { (mehrere Objects)
                  const hasObjectSeparator = /\}\s*,\s*\{/.test(textToParse);

                  // 3. Zähle Klammern
                  const countChar = (str: string, char: string) =>
                    (str.match(new RegExp('\\' + char, 'g')) || []).length;

                  const stats = {
                    openBrace: countChar(textToParse, '{'),
                    closeBrace: countChar(textToParse, '}'),
                    openBracket: countChar(textToParse, '['),
                    closeBracket: countChar(textToParse, ']'),
                    hasObjectSeparator,
                    startsWithBracket: textToParse.trimStart().startsWith('['),
                    endsWithBracket: textToParse.trimEnd().endsWith(']'),
                    startsWithBrace: textToParse.trimStart().startsWith('{'),
                    endsWithBrace: textToParse.trimEnd().endsWith('}'),
                  };

                  // console.log('JSON Structure Analysis:', stats);

                  // 4. Intelligente Reparatur basierend auf Pattern

                  // Strategie A: Mehrere Objects erkannt (}, {)
                  if (stats.hasObjectSeparator || stats.openBrace > 1) {
                    if (!stats.startsWithBracket) {
                      textToParse = '[' + textToParse;
                      // console.log('✓ Added [ (multiple objects)');
                    }
                    if (!stats.endsWithBracket) {
                      textToParse = textToParse + ']';
                      // console.log('✓ Added ] (multiple objects)');
                    }
                  }
                  // Strategie B: Einzelnes Object
                  else if (stats.openBrace === 1 && stats.closeBrace === 1) {
                    if (!stats.startsWithBracket || !stats.endsWithBracket) {
                      textToParse = '[' + textToParse + ']';
                      // console.log('✓ Wrapped single object in array');
                    }
                  }

                  // Strategie C: Unbalancierte Brackets
                  if (stats.openBracket > stats.closeBracket) {
                    const missing = stats.openBracket - stats.closeBracket;
                    textToParse = textToParse + ']'.repeat(missing);
                    // console.log(`✓ Added ${missing} closing ]`);
                  }
                  if (stats.closeBracket > stats.openBracket) {
                    const missing = stats.closeBracket - stats.openBracket;
                    textToParse = '['.repeat(missing) + textToParse;
                    // console.log(`✓ Added ${missing} opening [`);
                  }

                  // 5. Parse-Versuche
                  const parseAttempts = [
                    () => {
                      const parsed = JSON.parse(textToParse);
                      return Array.isArray(parsed) ? parsed : [parsed];
                    },
                    () => {
                      const repaired = jsonrepair(textToParse);
                      const parsed = JSON.parse(repaired);
                      return Array.isArray(parsed) ? parsed : [parsed];
                    },
                    // Notfall: Versuche einzelne Objects zu extrahieren
                    () => {
                      const objectMatches = textToParse.match(/\{[^{}]*\}/g);
                      if (objectMatches) {
                        return objectMatches.map((obj) => JSON.parse(obj));
                      }
                      return null;
                    },
                  ];

                  for (let i = 0; i < parseAttempts.length; i++) {
                    try {
                      const result = parseAttempts[i]();
                      if (result) {
                        // console.log(`✓ Parse successful (strategy ${i + 1})`);
                        return result;
                      }
                    } catch (error) {
                      // console.warn(`Parse attempt ${i + 1} failed:`, error);
                      continue;
                    }
                  }
                  return null;
                };

                // Nutze die Reparatur-Funktion
                c.suggestion = repairAndParseArray(evt.text);

                this.scrollToBottom();
                this.cd.detectChanges();
                break;

              case ResponseType.TEXT:
                let reworked = await this.checkModeForKeyQuestionInString(
                  evt.text,
                );
                c.text = reworked.text;
                c.keyQuestion = reworked.keyQuestionNumber;

                this.scrollToBottom();
                this.cd.detectChanges();
                break;
            }
          } else if (evt.type === 'meta') {
            if (evt.meta.threadId) {
              this.currentThreadId = evt.meta.threadId;
            }
          } else if (evt.type === 'error') {
            this.error = evt.error || 'Unbekannter Fehler';
            c.finished = true;
            this.enableChatWindow();
            this.contentChangedForClosing = true;
            c.aiRunning = false;
            this.cd.detectChanges();
          } else if (evt.type === 'done') {
            this.enableChatWindow();
            c.finished = true;
            this.updateHistory();
            this.checkSuggestBtnActiveAnd();
            this.contentChangedForClosing = true;
            this.scrollToBottom();
            c.aiRunning = false;
            this.cd.detectChanges();
            if (c.keyQuestion !== undefined) {
              // console.log('currentKeyQuestionIndex', c.keyQuestion);
              this.currentKeyQuestionIndex = c.keyQuestion;
              this.currentKeyQuestions.forEach((question, i) => {
                question.active = i === c.keyQuestion;
              });
            } else {
              // console.log(
              //   'No key question found',
              //   'currentKeyQuestionIndex',
              //   this.currentKeyQuestionIndex,
              //   c,
              // );
            }
            // Proceed link Btn
            if (this.turnCounter === this.turnCounterValueForNextQuestion) {
              this.turnCounter = 0;
              c.skipToNextQuestionBtn = true;
            } else {
              if (hidden === false) {
                this.turnCounter++;
              }
            }

            if (
              this.currentStep === 0 &&
              this.currentKeyQuestionIndex === 0 &&
              c.responseType === ResponseType.TEXT
            ) {
              c.uploadBtn = true;
            } else {
              c.uploadBtn = false;
            }
            this.cd.detectChanges();
          }
        });
      });
  }
  uploadDocs(sumaryDocument: any = undefined) {
    let dia = this.dialog.open(UserRagComponent, {
      panelClass: 'small-dialog',
      data: sumaryDocument,
      autoFocus: false,
      disableClose: true,
    });

    dia.afterClosed().subscribe((result) => {
      if (result === 'closed') {
        if (this.currentKeyQuestionIndex === 0) {
          this.proceedWithNextKeyQuestion();
          return;
        } else {
          return;
        }
      }
      if (!result) {
        this.proceedWithNextKeyQuestion();
        return;
      }

      if (this.uploadCounter < this.uploadLimiter) {
        this.uploadCounter++;
      } else {
        alert('You have reached the upload limit for this session.');
        console.warn('Upload limit reached');
        return;
      }

      if (!this.briefingMaterial) {
        this.briefingMaterial = [result];
      } else {
        this.briefingMaterial.push(result);
      }
      this.addBriefingMaterialToChat();
    });
  }
  async addBriefingMaterialToChat() {
    let userChatId = `user-${new Date().getTime()}`;
    let id = `llm-${new Date().getTime()}`;

    this.chat.push({
      id: userChatId,
      text: '',
      textType: TextType.USER,
      finished: false,
      responseType: ResponseType.TEXT,
      hidden: true,
    });
    this.cd.detectChanges();
    this.chat.push({
      id: id,
      textType: TextType.AI,
      finished: false,
      hidden: false,
      aiRunning: true,
    });

    let promptType: GenericChatTypesUi = GenericChatTypesUi.STANDALONE;
    let promptId: string | undefined = 'GEN_DocChatintegration';

    let lastBriefingObject =
      this.briefingMaterial![this.briefingMaterial!.length - 1];
    let content = `<BRIEFING MATERIAL>
${JSON.stringify(lastBriefingObject, null, 2)}
</BRIEFING MATERIAL>`;
    this.llmChat(id, promptType, content, promptId);

    if (!this.userStream?.results) {
      this.userStream!.results = [];
    }

    let exist = this.userStream?.results.find(
      (r) =>
        r.stepId ===
        this.streamData!.steps[this.currentStep].id + '-briefing-material',
    );
    if (!exist) {
      this.userStream?.results.push({
        stepId:
          this.streamData!.steps[this.currentStep].id + '-briefing-material',
        name: 'Briefing Material',
        created: new Date().getTime(),
        type: 'briefing-material',
        variant: 'generic',
        data: this.briefingMaterial,
      });
    } else {
      for (let r of this.userStream!.results) {
        if (
          r.stepId ===
          this.streamData!.steps[this.currentStep].id + '-briefing-material'
        ) {
          r.data = this.briefingMaterial;
        }
      }
    }
    console.log('Results', this.userStream?.results);
    this.genService.updateGenericUserStreamResults(
      this.userStream!.id,
      this.userStream?.results || [],
    );
  }
  goahead() {
    let content = 'i dont have briefing material, jump to q2.';

    let userChatId = `user-${new Date().getTime()}`;
    let id = `llm-${new Date().getTime()}`;

    this.chat.push({
      id: userChatId,
      text: '',
      textType: TextType.USER,
      finished: false,
      responseType: ResponseType.TEXT,
      hidden: true,
    });
    this.cd.detectChanges();
    this.chat.push({
      id: id,
      textType: TextType.AI,
      finished: false,
      hidden: false,
      aiRunning: true,
    });

    let promptType: GenericChatTypesUi = GenericChatTypesUi.DOC_UPLOAD;
    let promptId: string | undefined = undefined;

    this.llmChat(id, promptType, content, promptId);
  }
  disableChatWindow() {
    this.textareaEl.nativeElement.setAttribute('disabled', 'true');
    this.disableInput = true;
    this.aiRunning = true;
  }

  enableChatWindow() {
    this.textareaEl.nativeElement.setAttribute('disabled', 'false');
    this.stop();
    this.disableInput = false;
    this.aiRunning = false;
    if (this.textareaEl && this.textareaEl.nativeElement) {
      this.textareaEl.nativeElement.focus();
    }
  }
  doWebSearch() {
    this.showSubmenue = false;
    let questions = this.streamData?.steps[this.currentStep]?.websearch || [];
    if (questions.length === 0) return;
    let dia = this.dialog.open(WebresearchComponent, {
      data: questions,
      panelClass: 'small-dialog',
      autoFocus: false,
    });

    dia.afterClosed().subscribe((result) => {
      if (result) {
        // Do websearch => config in result
        this.dialog.open(SearchResultComponent, { data: {} });
      }
    });
  }
  async nextStep() {
    this.updateHistory();
    let existOpenQuestions = this.currentKeyQuestions.filter(
      (q) => q.resolved === false,
    );
    if (existOpenQuestions && existOpenQuestions.length > 0) {
      // alert("There are unresolved questions.");
      let dia = this.dialog.open(StepNotCompletedComponent, {
        panelClass: 'small-dialog',
        autoFocus: false,
        disableClose: true,
        data: {
          state: OpenQuestionDialogState.NEXT,
          questions: this.currentKeyQuestions,
        },
      });

      dia.afterClosed().subscribe(async (choise) => {
        if (choise) {
          if (choise !== true) {
            this.setKeyQuestionActive(choise);
          }
          return;
        } else {
          let r = await this.generateClosing();
          if (r === false) return;
          if (this.currentStep < this.streamData?.steps?.length! - 1) {
            this.technicalStepChange(true);
          } else {
            this.router.navigate(
              ['/generic-stream', 'result', this.userStream!.id],
              { queryParams: { cid: this.streamData!.id } },
            );
          }
        }
      });

      return;
    }

    let r = await this.generateClosing();
    if (r === false) return;
    if (this.currentStep < (this.streamData?.steps?.length! - 1 || 0)) {
      this.technicalStepChange(true);
    } else {
      this.router.navigate(['/generic-stream', 'result', this.userStream!.id], {
        queryParams: { cid: this.streamData!.id },
      });
    }
  }
  async back() {
    this.updateHistory();
    if (this.currentStep > 0) {
      this.technicalStepChange();
    } else if (this.currentStep === 0) {
      let dia2 = this.dialog.open(CloseStreamComponent, {
        panelClass: 'small-dialog',
      });

      dia2.afterClosed().subscribe((result) => {
        if (result === true) {
          this.router.navigate(['/home/user']);
        }
      });
    }
  }

  async technicalStepChange(next: boolean = false): Promise<void> {
    if (next === true) {
      this.currentStep++;
      this.cd.detectChanges();
    } else {
      this.currentStep--;
      this.cd.detectChanges();
    }
    // console.log("Updated Step:", this.currentStep);
    this.chat = [];
    this.currentKeyQuestions = [];
    this.currentThreadId = this.userStream!.history[0].threadId || undefined;
    this.contentChangedForClosing = false;
    this.suggestBtnActive = false;
    this.userStream!.currentStepId =
      this.streamData!.steps[this.currentStep].id;
    this.genService.updateGenericUserStreamCurrentStep(
      this.userStream!.id,
      this.streamData!.steps[this.currentStep].id,
    );
    this.initializeStep();
    this.cd.detectChanges();
  }

  scrollToBottom(): void {
    try {
      setTimeout(() => {
        if (this.chatContent?.nativeElement)
          this.chatContent.nativeElement.scrollTop =
            this.chatContent.nativeElement.scrollHeight;
      }, 100);
    } catch (err) { }
  }
  stop() {
    this.sub?.unsubscribe();
    this.sub = undefined;
    this.chatInput.enable();
  }
  async ngOnDestroy(): Promise<void> {
    // ToDo: clear chat? perhaps delete some things Serverside?
    // await this.updateHistory();
    this.stop();
    this.dialog.closeAll();
  }

  private isKeyQuestionInViewPort(index: number): boolean {
    const targetQuestion =
      this.targetKeyQuestion.toArray()[index]?.nativeElement;
    const container = this.keyQuestionsScrollContainer.nativeElement;

    if (!targetQuestion.className.includes('active')) {
      return true;
    }

    const elRect = targetQuestion.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    // Container's visible area in page coordinates
    const containerTop = containerRect.top;
    const containerBottom = containerRect.bottom;
    const containerLeft = containerRect.left;
    const containerRight = containerRect.right;

    // Element bounds in page coordinates
    const elTop = elRect.top;
    const elBottom = elRect.bottom;
    const elLeft = elRect.left;
    const elRight = elRect.right;

    // Visible area = overlap between element and container
    const visibleTop = Math.max(elTop, containerTop);
    const visibleBottom = Math.min(elBottom, containerBottom);
    const visibleLeft = Math.max(elLeft, containerLeft);
    const visibleRight = Math.min(elRight, containerRight);

    const visibleHeight = Math.max(0, visibleBottom - visibleTop);
    const visibleWidth = Math.max(0, visibleRight - visibleLeft);

    const elArea = elRect.width * elRect.height;
    const visibleArea = visibleWidth * visibleHeight;

    if (elArea === 0) {
      return false;
    }

    return visibleArea / elArea === 1;
  }

  private scrollToElement(index: number) {
    this.targetKeyQuestion.toArray()[index]?.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }

  private autoResizeTextarea(): void {
    const textarea = this.textareaEl.nativeElement;

    if (!textarea) {
      return;
    }

    const autoResize = (): void => {
      textarea.style.height = 'auto';
      textarea.style.height =
        Math.min(textarea.scrollHeight, TEXTAREA_MAX_HEIGHT) + 'px';
      textarea.style.overflowY =
        textarea.scrollHeight > TEXTAREA_MAX_HEIGHT ? 'auto' : 'hidden';
    };

    textarea.addEventListener('input', autoResize);

    this.chatInput.valueChanges
      .pipe(
        tap((value) => {
          if (!value) {
            autoResize();
          }
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
